import { Component, Input, OnInit } from '@angular/core';
import { ChartColorProvider, DashboardColorTypes } from '@app/helpers/chartColorProvider';
import { localeNumberFormat } from '@app/helpers/number-formater';
import { TranslationService } from '@services/translation.service';
import { ColumnChartMultipleComponent } from '../../../components/charts/column-chart-multiple/column-chart-multiple.component';

@Component({
    selector: 'app-compare-column-chart',
    templateUrl: './compare-column-chart.component.html',
    styleUrls: ['./compare-column-chart.component.scss'],
    imports: [ColumnChartMultipleComponent]
})
export class CompareColumnChartComponent implements OnInit {

	constructor(private translationService: TranslationService, private chartColorProvider: ChartColorProvider) { }

	public compareData = [];
	private defaultColors = this.chartColorProvider.getColors()
	@Input() data: CompareColumnData[];
	@Input() isSorting = true;
	@Input() maxValue?: number;
	@Input() height?: string; // with px or rem, eg. 


	ngOnInit(): void {
		const origins = [];
		const gains = [];
		const losts = [];
		const currents = [];
		const froms = [];
		if (this.isSorting) {
			this.data.sort((a, b) => a.to < b.to ? 1 : -1)
		}
		this.data.forEach((item, idx) => {
			const difference = item.to - item.from;
			const color = item.color ? item.color : this.defaultColors[idx % (this.defaultColors.length - 1)]
			const category = this.translationService.getByKey(item.categoryKey);
			const origin = this.translationService.getByKey(item.originKey ? item.originKey : "kendoui.compare-column.origin");
			const gain = this.translationService.getByKey(item.gainKey ? item.gainKey : "kendoui.compare-column.gain");
			const lost = this.translationService.getByKey(item.lostKey ? item.lostKey : "kendoui.compare-column.lost");
			const current = this.translationService.getByKey(item.currentKey ? item.currentKey : "kendoui.compare-column.current");
			const plusColor = item.isNeutralPlus ? DashboardColorTypes.neutralPlus : DashboardColorTypes.plus;
			froms.push({ category, value: item.from, series: 'origin', seriesName: origin, group: "group0", color, summit: item.fromSummitKey });
			if (difference > 0) {
				origins.push({ category, value: item.from, series: 'origin', seriesName: origin, group: "group1", color, summit: item.toSummitKey });
				gains.push({ category, value: difference, series: 'gain', seriesName: gain, group: "group1", label: `+${localeNumberFormat(difference)}`, color: this.chartColorProvider.getColor(plusColor), labelColor: this.chartColorProvider.getColor(plusColor), summit: item.toSummitKey });
			} else if (difference < 0) {
				currents.push({ category, value: (item.from + difference), series: 'origin', seriesName: current, color, group: "group1", summit: item.fromSummitKey });
				losts.push({ category, value: -difference, series: 'lost', seriesName: lost, group: "group1", label: `${localeNumberFormat(difference)}`, color: this.chartColorProvider.getColor(DashboardColorTypes.filling), labelColor: this.chartColorProvider.getColor(DashboardColorTypes.dark), summit: item.fromSummitKey });
			} else {
				origins.push({ category, value: item.from, series: 'origin', seriesName: origin, group: "group1", color, summit: item.toSummitKey });
			}

		})
		// Wegen Anzeigereihenfolge der Stacks und groups müssen die Daten in einer bestimmten Reihenfolge konkatiniert werden
		this.compareData = froms.concat(currents).concat(origins).concat(losts).concat(gains);
	}
}

export interface CompareColumnData {
	categoryKey: string,
	from: number,
	to: number,
	color?: string,
	originKey?: string,
	gainKey?: string,
	lostKey?: string,
	currentKey?: string,
	fromSummitKey?: string,
	toSummitKey?: string,
	isNeutralPlus?: boolean
}